import firebase from 'firebase/app';
import { set, get, remove } from '../../storage';

export default class AxiosImportantRequestRepeaterStrategy {
  static STORAGE_KEY = 'requests:failed';

  constructor(next, repeat) {
    this.next = next;
    this.repeat = repeat;
    this.reqs = this.load();

    this.startTimer();
  }

  onDataUpdated() {
    if (this.reqs.length === 1) {
      this.startTimer();
    }

    this.save();
  }

  addReq(value) {
    this.reqs.push(value);
    this.onDataUpdated();
  }

  removeReq(valueToReplace) {
    this.reqs = this.reqs.filter((r) => r !== valueToReplace);
    this.onDataUpdated();
  }

  mergeReq(value) {
    if (!value.stack) {
      return value;
    }

    const similarRequest = this.findSimilarReq(value);

    if (!similarRequest) {
      return value;
    }

    const currData = JSON.parse(value.data);
    const prevData = JSON.parse(similarRequest.data);
    const newData = JSON.stringify({ ...prevData, ...currData });
    const newReq = { ...similarRequest, data: newData };

    this.removeReq(similarRequest);

    return newReq;
  }

  isSameReq(req1, req2) {
    return req1.baseUrl === req2.baseUrl && req1.url === req2.url && req1.method === req2.method;
  }

  findSimilarReq(req) {
    return this.reqs.find((r) => this.isSameReq(r, req));
  }

  clearReqs() {
    this.reqs = [];
    this.save();
  }

  load() {
    return get(AxiosImportantRequestRepeaterStrategy.STORAGE_KEY) || [];
  }

  save() {
    const key = AxiosImportantRequestRepeaterStrategy.STORAGE_KEY;
    set(key, this.reqs);
  }

  startTimer(timeout = 10000) {
    clearTimeout(this.reqTimer);
    this.reqTimer = setTimeout(() => this.makeRequests(), timeout, this);
  }

  makeRequests() {
    clearTimeout(this.reqTimer);
    const reqsToRepeat = this.reqs;
    this.clearReqs();
    return Promise.all(reqsToRepeat.map((req) => this.repeat(req)));
  }

  makeSomeRequests(predicate) {
    const reqs = this.reqs.filter(predicate);

    if (!reqs.length) {
      return Promise.resolve();
    }

    const rest = this.reqs.filter((r) => !predicate(r));
    this.reqs = rest;

    return Promise.all(reqs.map((req) => this.repeat(req)));
  }

  fail(error) {
    const { config } = error;

    if (!config.important) {
      return this.next.fail(error);
    }

    this.addReq(this.mergeReq(config));

    return this.next.fail(error);
  }

  success(response) {
    this.makeRequests();

    return this.next.success(response);
  }
}

firebase.auth().onAuthStateChanged((user) => {
  if (!user) {
    remove(AxiosImportantRequestRepeaterStrategy.STORAGE_KEY);
  }
});
